import { render, staticRenderFns } from "./inquiryCreate.vue?vue&type=template&id=59b5235a&scoped=true"
import script from "./inquiryCreate.vue?vue&type=script&lang=js"
export * from "./inquiryCreate.vue?vue&type=script&lang=js"
import style0 from "./inquiryCreate.vue?vue&type=style&index=0&id=59b5235a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b5235a",
  null
  
)

export default component.exports